
    import './styles.scoped.css';
    export default {
  "visible-content": "awsui_visible-content_tc96w_1mjn3_185",
  "visible-content-toggle": "awsui_visible-content-toggle_tc96w_1mjn3_186",
  "visible-content-groups": "awsui_visible-content-groups_tc96w_1mjn3_187",
  "visible-content-group": "awsui_visible-content-group_tc96w_1mjn3_187",
  "visible-content-title": "awsui_visible-content-title_tc96w_1mjn3_192",
  "visible-content-group-label": "awsui_visible-content-group-label_tc96w_1mjn3_202",
  "visible-content-option": "awsui_visible-content-option_tc96w_1mjn3_208",
  "visible-content-option-label": "awsui_visible-content-option-label_tc96w_1mjn3_221",
  "content-display-option-toggle": "awsui_content-display-option-toggle_tc96w_1mjn3_412",
  "content-display-option-content": "awsui_content-display-option-content_tc96w_1mjn3_416",
  "content-display-option": "awsui_content-display-option_tc96w_1mjn3_412",
  "placeholder": "awsui_placeholder_tc96w_1mjn3_444",
  "sorting": "awsui_sorting_tc96w_1mjn3_444",
  "content-display-option-label": "awsui_content-display-option-label_tc96w_1mjn3_471",
  "drag-overlay": "awsui_drag-overlay_tc96w_1mjn3_478",
  "content-display": "awsui_content-display_tc96w_1mjn3_412",
  "content-display-title": "awsui_content-display-title_tc96w_1mjn3_508",
  "content-display-description": "awsui_content-display-description_tc96w_1mjn3_517",
  "content-display-option-list": "awsui_content-display-option-list_tc96w_1mjn3_525",
  "root": "awsui_root_tc96w_1mjn3_532",
  "modal-root": "awsui_modal-root_tc96w_1mjn3_533",
  "trigger-button": "awsui_trigger-button_tc96w_1mjn3_534",
  "cancel-button": "awsui_cancel-button_tc96w_1mjn3_535",
  "confirm-button": "awsui_confirm-button_tc96w_1mjn3_536",
  "custom": "awsui_custom_tc96w_1mjn3_537",
  "second-column-small": "awsui_second-column-small_tc96w_1mjn3_541",
  "wrap-lines": "awsui_wrap-lines_tc96w_1mjn3_545",
  "striped-rows": "awsui_striped-rows_tc96w_1mjn3_546",
  "content-density": "awsui_content-density_tc96w_1mjn3_547",
  "page-size": "awsui_page-size_tc96w_1mjn3_548",
  "page-size-form-field": "awsui_page-size-form-field_tc96w_1mjn3_549",
  "page-size-radio-group": "awsui_page-size-radio-group_tc96w_1mjn3_550",
  "sticky-columns": "awsui_sticky-columns_tc96w_1mjn3_551",
  "sticky-columns-form-field": "awsui_sticky-columns-form-field_tc96w_1mjn3_552",
  "sticky-columns-radio-group": "awsui_sticky-columns-radio-group_tc96w_1mjn3_553",
  "sticky-columns-first": "awsui_sticky-columns-first_tc96w_1mjn3_554",
  "sticky-columns-last": "awsui_sticky-columns-last_tc96w_1mjn3_555"
};
  